import React from "react";
import { Icon } from "@iconify/react";
import javaIcon from "@iconify/icons-logos/java";
import reactIcon from "@iconify/icons-logos/react";
import angularIcon from "@iconify/icons-logos/angular";
import cplusplus from "@iconify/icons-logos/c-plusplus";
import javascript from "@iconify/icons-logos/javascript";
import aws from "@iconify/icons-logos/aws";
import github from "@iconify/icons-logos/github";
import html from "@iconify/icons-logos/html-5";
import css from "@iconify/icons-logos/css-3";
import git from "@iconify/icons-logos/git";
import spring from "@iconify/icons-logos/spring";
import mysql from "@iconify/icons-logos/mysql";
import oracle from "@iconify/icons-logos/oracle";
import postgresql from "@iconify/icons-logos/postgresql";
import firebase from "@iconify/icons-logos/firebase";
import hibernate from "@iconify/icons-logos/hibernate";
import docker from "@iconify/icons-logos/docker";
import jenkins from "@iconify/icons-logos/jenkins";

import POS from "../../src/Projects/pos.jpg";
import CRM from "../../src/Projects/CRM.PNG";
import EPID from "../../src/Projects/EPID.PNG";
import eportal from "../../src/Projects/eportal.gif";
import mediport from "../../src/Projects/mediport.PNG";
import mobileService from "../../src/Projects/MobileService.PNG";
import MSD from "../../src/Projects/MSD.PNG";
import MYHR from "../../src/Projects/MYHR.png";
import ProntoERP from "../../src/Projects/ProntoERP.PNG";
import prontoService from "../../src/Projects/prontoService.PNG";
import ecom from "../../src/Projects/ecom.PNG";
import fin from "../../src/Projects/fin.png";

const Home = () => {
  const words = [
    "Chamara Silva",
    "Full Stack Developer",
    "ERP Specialist",
    "Financial Systems Expert",
    "Web Development Guru",
    "Experienced Problem Solver",
    "Passionate Tech Enthusiast",
    "UI / UX Designer",
    "Code Craftsman",
    "Technology Innovator",
    "Agile Methodology Advocate",
  ];
  // Your skill data
  const skills = [
    { icon: javaIcon, name: "Java" },
    { icon: reactIcon, name: "React" },
    { icon: angularIcon, name: "Angular" },
    { icon: javascript, name: "javascript" },
    { icon: cplusplus, name: "C++" },
    { icon: aws, name: "aws" },
    { icon: github, name: "github" },
    { icon: html, name: "html" },
    { icon: css, name: "css" },
    { icon: git, name: "git" },
    { icon: spring, name: "spring" },
    { icon: mysql, name: "mysql" },
    { icon: oracle, name: "oracle" },
    { icon: postgresql, name: "postgresql" },
    { icon: firebase, name: "firebase" },
    { icon: hibernate, name: "hibernate" },
    { icon: docker, name: "docker" },
    { icon: jenkins, name: "jenkins" },
  ];

  return (
    <React.StrictMode>
      <div className="main-page-content">
        <div id="home">
          <div id="particles-js"></div>
          <div className="home-content-main">
            <div className="table-cell">
              <div className="container">
                <div className="row home-row">
                  <div className="col-md-12 col-sm-12">
                    <div className="home-text wow fadeIn text-center">
                      <h1 className="cd-headline clip is-full-width">
                        <span className="cd-words-wrapper">
                          {words.map((word, index) => (
                            <b
                              key={index}
                              className={`cd-word ${
                                index === 0 ? "is-visible" : "is-hidden"
                              }`}
                            >
                              {word}
                            </b>
                          ))}
                        </span>
                      </h1>
                      <div className="about-social-icon text-center">
                        <ul className="about-social">
                          <li className="wow fadeIn" data-wow-delay=".2s">
                            <a
                              href="https://www.linkedin.com/in/chamara-silva-34ba5138"
                              target="newtab"
                            >
                              <i
                                className="fa fa-linkedin"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".4s">
                            <a
                              href="https://github.com/chamrasilva89"
                              target="newtab"
                            >
                              <i
                                className="fa fa-github"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".6s">
                            <a
                              href="https://stackoverflow.com/users/11629865/chamara-silva"
                              target="newtab"
                            >
                              <i
                                className="fa fa-stack-overflow"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".8s">
                            <a
                              href="https://www.instagram.com/chamiisilva/?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D"
                              target="newtab"
                            >
                              <i
                                className="fa fa-instagram"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay="1s">
                            <a
                              href="https://dev.to/chamrasilva89"
                              target="newtab"
                            >
                              <i className="fa fa-book" aria-hidden="true"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="parallax" data-velocity="-.1"></div>
          <div className="parallax" data-velocity="-.5" data-fit="525"></div>
        </div>

        {/* <!-- ================================ ABOUT =============================== --> */}

        <div id="about">
          <div className="about-content">
            <div className="love-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>What I do</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        I'm a Full Stack Developer at Pronto Software Ltd.,
                        specializing in React, React Native, and Angular for
                        front-end work, and utilizing C++ and Java for backend
                        development. Additionally, I lead a core team focused on
                        creating ERP functionalities using Pronto 4GL.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row love-row wow fadeIn">
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".1s">
                      <i
                        className="fa fa-pencil-square-o love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>Working Hard</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>Always believe in hard-work in my profession</p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".3s">
                      <i
                        className="fa fa-file-image-o love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>UI/UX Design</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>Love to do UI/UX design for new product</p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".2s">
                      <i
                        className="fa fa-globe love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>Web Design</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>Passionate about Web Design from start</p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".4s">
                      <i className="fa fa-cog love-icon" aria-hidden="true"></i>
                      <h3>Web Development</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>Created all types of modern web development.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-back"></div>
            <div className="me-grid">
              <div className="container">
                <div className="row">
                  <div className="col-md-4 col-sm-6 col-xs-12 about-col">
                    <div className="about-image">
                      <img
                        src="assets/img/pic.jpg"
                        alt="sanajit-jana"
                        className="about-img wow fadeIn"
                      />
                    </div>
                  </div>
                  <div className="col-md-8 col-sm-6 col-xs-12 about-col">
                    <div className="about-details wow fadeIn">
                      <div className="main-title left-title text-left wow fadeIn">
                        <h3>Hello! This is Chamara</h3>
                        <div className="underline1 no-margin"></div>
                        <div className="underline2 no-margin"></div>
                      </div>
                      <p className="wow fadeIn">
                        Hello from Sri Lanka! I thrive as a Full Stack
                        Developer, where my passion lies in crafting diverse
                        digital landscapes – from elegant small business
                        websites to immersive interactive web applications,
                        robust ERP systems, and the pulse of real-time
                        applications{" "}
                        <a className="underline2" href="#contact">
                          {" "}
                          here.
                        </a>{" "}
                        If you're in pursuit of a dynamic professional with over
                        a decade of expertise in the ever-evolving IT domain,
                        I'm your person. Let's connect and turn your ideas into
                        extraordinary digital realities.
                        <br />
                      </p>
                      <a
                        className="about-link-1"
                        href="assets/cv/Chamara_Silva_Application_Resume.pdf"
                        target="_blank"
                      >
                        See Resume
                      </a>
                      <a className="about-link-2" href="#contact">
                        Hire Me
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="work-counter text-center">
              <div className="counter">
                <div className="container">
                  <div className="row wow fadeIn">
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-pencil-square-o stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0021</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>Web Design Completed</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-crop stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0040</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>UI/UX Design Done</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-bolt stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0015</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>Website Created</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-coffee stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0085</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>Cups Coffee Taken</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- ================================ Skill =============================== --> */}

        <div id="skill">
          <div className="skill-main">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="main-title text-center wow fadeIn">
                    <h3>My Skill</h3>
                    <div className="underline1"></div>
                    <div className="underline2"></div>
                    <p>
                      I value simple content structure, clean design patterns,
                      and thoughtful interactions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row love-row wow fadeIn" id="skillTiles">
                {skills.map((skill, index) => (
                  <div
                    key={index}
                    className="col-md-2 col-sm-4 custom-col-spacing"
                  >
                    <div
                      className="skill-details"
                      data-wow-delay={`${index * 0.1}s`}
                    >
                      <Icon icon={skill.icon} className="skill-logo" />
                      <h3>{skill.name}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- ================================ RESUME =============================== --> */}

        <div id="resume">
          <div className="resume-content">
            <div className="resume-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>Educational Story</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        I like to code things from scratch, and enjoy bringing
                        ideas to life in the browser.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row love-row wow fadeIn">
                  <div className="col-md-4 col-sm-4">
                    <div className="resume-details" data-wow-delay=".3s">
                      <div className="resume-hover"></div>
                      <div className="resume-main">
                        <i
                          className="fa fa-graduation-cap resume-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Bachelor of Science in IT</h3>
                        <h2>2009-2013</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Achieved my bachelor's degree from{" "}
                          <a
                            href="https://www.curtin.edu.au/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Curtin University
                          </a>
                          ,Perth Western Australia, 6845.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="resume-details" data-wow-delay=".3s">
                      <div className="resume-hover"></div>
                      <div className="resume-main">
                        <i
                          className="fa fa-graduation-cap resume-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Higher diploma in IT</h3>
                        <h2>2009-2012</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Achieved Higher diploma from{" "}
                          <a
                            href="https://www.sliit.lk/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            SLIIT Malabe Campus
                          </a>
                          ,New Kandy Road, Malabe.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row main-row wow fadeIn">
                  <div className="col-md-12">
                    <div className="main-title text-center">
                      <h3>Working Experience</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>I have worked in few global companies.</p>
                    </div>
                  </div>
                </div>
                <div className="row love-row">
                  <div className="col-md-4 col-sm-4">
                    <div className="exp-details" data-wow-delay=".2s">
                      <div className="exp-hover"></div>
                      <div className="exp-main">
                        <i
                          className="fa fa-building exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>
                          <a
                            href="https://www.pronto.net/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#4d4d4d" }}
                          >
                            Pronto Software Pvt Ltd
                          </a>
                        </h3>
                        <h4>Senior Software Engineer</h4>
                        <h2>2021-Present</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="exp-details" data-wow-delay=".3s">
                      <div className="exp-hover"></div>
                      <div className="exp-main">
                        <i
                          className="fa fa-building exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>
                          <a
                            href="https://www.lseg.com/en/about-us/what-we-do"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#4d4d4d" }}
                          >
                            London Stock Exchange
                          </a>
                        </h3>
                        <h4>Special Software Engineer</h4>
                        <h2>2020-2022</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="exp-details" data-wow-delay=".4s">
                      <div className="exp-hover"></div>
                      <div className="exp-main">
                        <i
                          className="fa fa-cogs exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>
                          <a
                            href="https://ewisl.net/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#4d4d4d" }}
                          >
                            E-W Information System Ltd
                          </a>
                        </h3>
                        <h4>Technical Lead</h4>
                        <h2>2012-2018</h2>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- ================================ WORK =============================== --> */}
        <div id="work">
          <div className="work-content">
            <div className="work-grid">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>Work Portfolio</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        Here are a few of my past completed works.{" "}
                        <a className="underline2" href="#contact">
                          contact me.
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="gallery" style={{ paddingTop: "80px" }}>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={POS}
                        alt="Point of sales system"
                      />
                      <div className="project-title">Point of Sale</div>
                    </div>
                  </button>

                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={CRM}
                        alt="customer releationship management system"
                      />
                      <div className="project-title">CRM</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={EPID}
                        alt="epidomology vacinne tracking system"
                      />
                      <div className="project-title">Epidomology</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={eportal}
                        alt="document management system"
                      />
                      <div className="project-title">E Portal</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={mediport}
                        alt="medical item maintenance system"
                      />
                      <div className="project-title">Mediport</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={mobileService}
                        alt="Engineer service app"
                      />
                      <div className="project-title">Mobile Service</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={MSD}
                        alt="web site for medical supplier devision"
                      />
                      <div className="project-title">
                        Medical Supplier Devision
                      </div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={MYHR}
                        alt="MYHR hr management software"
                      />
                      <div className="project-title">MYHR</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={ProntoERP}
                        alt="pronto erp system with all modules"
                      />
                      <div className="project-title">ERP System</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={prontoService}
                        alt="pronto service app for engineers"
                      />
                      <div className="project-title">Service App</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={ecom}
                        alt="e-commerce web site"
                      />
                      <div className="project-title">E-Commerce</div>
                    </div>
                  </button>
                  <button className="gallery-button">
                    <div className="gallery-item">
                      <img
                        className="gallery-image"
                        src={fin}
                        alt="Financial Management system"
                      />
                      <div className="project-title">Finance Management</div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- ============================================== SERVICE ===================================================== --> */}
        <div id="service">
          <div className="service-content">
            <div className="service-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>My Service List</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        I always want to make things that make a difference.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row love-row wow fadeIn">
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/design-development.jpg"
                          alt="design-development"
                        />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-edit service-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Design + Development</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Creating clean and contemporary designs that
                          prioritize performance, search engine optimization,
                          and the seamless transformation of users into
                          customers..
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/e-commarce.jpg"
                          alt="e-commarce"
                        />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-cart-plus exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>eCommerce</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Seamlessly integrating eCommerce platforms, payment
                          gateways, customized product templates, and a range of
                          other functionalities.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/analytics.jpg"
                          alt="analytics"
                        />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-tachometer service-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>ERP Development</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Proficient in the comprehensive design and development
                          of ERP systems, ranging from large-scale
                          implementations to medium-scale solutions.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/mobile-friendly.jpg"
                          alt="mobile-friendly"
                        />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-desktop exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Mobile-friendly</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Implementing a responsive design ensures your
                          website's accessibility across all devices, catering
                          to a diverse range of users.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/website-audit.jpg"
                          alt="website-audit"
                        />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-search exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Website Rank</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Interested in enhancing your page performance, SEO, or
                          user experience? Feel free to request a complimentary
                          site audit.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img
                          src="assets/img/service/content-management.jpg"
                          alt="content-management"
                        />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-file exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Content Management</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Crafting themes and plugins for your needs. Empowering
                          you to effortlessly manage site content with
                          proficiency in impactful coding techniques.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial-content">
                <div className="testimonial-grid">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="main-title text-center wow fadeIn">
                          <h3>Testimonials</h3>
                          <div className="underline1"></div>
                          <div className="underline2"></div>
                          <p>
                            People I've worked with have said some nice things
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-details">
                    <section id="carousel">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-8 col-md-offset-2">
                            <div className="quote">
                              <i className="fa fa-quote-left fa-4x"></i>
                            </div>
                            <div
                              className="carousel slide"
                              id="fade-quote-carousel"
                              data-ride="carousel"
                              data-interval="3000"
                            >
                              <ol className="carousel-indicators">
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="0"
                                  className="active"
                                ></li>
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="1"
                                ></li>
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="2"
                                ></li>
                              </ol>
                              <div className="carousel-inner">
                                <div className="active item">
                                  <blockquote>
                                    <p>
                                      “Working with Chamara was an absolute
                                      pleasure. We eagerly anticipate the
                                      opportunity to collaborate with him again.
                                      He is undoubtedly the type of developer
                                      you can rely on to handle a project from
                                      its inception to its conclusion.”
                                      <br />
                                      <span>
                                        Tim Lee - CHEP Pallecon Solutions -
                                        Australia{" "}
                                      </span>
                                    </p>
                                  </blockquote>
                                </div>
                                <div className="item">
                                  <blockquote>
                                    <p>
                                      “Chamara is a clear communicator with the
                                      determination and confidence to delve deep
                                      into intricate design challenges. He also
                                      possesses the collaborative spirit
                                      necessary to generate exceptional
                                      outcomes.”
                                      <br />
                                      <span>
                                        Dr.Chathura Edirisooriya -
                                        Epidemiologist - World Health
                                        Organization{" "}
                                      </span>
                                    </p>
                                  </blockquote>
                                </div>
                                <div className="item">
                                  <blockquote>
                                    <p>
                                      “Chamara has done an outstanding job
                                      overall. Not only is the site
                                      well-designed, but the code is also clean
                                      and polished. I'm particularly impressed
                                      with how he handled the translations
                                      section of the site.”
                                      <br />
                                      <span>Jayantha Bandara - HNB Bank</span>
                                    </p>
                                  </blockquote>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- ================================ BLOG ========================== --> */}
        <div id="blog">
          <div className="blog-content">
            <div className="blog-grid">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>My Blog</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        The Blog, Which has thoughts on life, work and
                        everything in between.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="blog-details wow fadeIn text-left">
                <div className="container">
                  <div className="row">
                    <div className="col-md-4 col-sm-6">
                      <div className="blog-main">
                        <a
                          href="https://dev.to/chamrasilva89/importance-of-reacts-hooks-b49"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="assets/img/blog/blog1.png"
                            alt="React hooks were introduced in version 16.8"
                            className="blog-img"
                          />
                        </a>
                        <div className="blog-head">
                          <a
                            href="https://dev.to/chamrasilva89/importance-of-reacts-hooks-b49"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <h3>
                              <strong>
                                What is the importance of hooks in React JS?
                              </strong>
                            </h3>
                          </a>
                        </div>
                        <div className="blog-bottom">
                          <p>
                            In this article, you will learn what are hooks in
                            React JS? and when to use react hooks? React JS is
                            developed by Facebook in the year 2013. There are
                            many students and the new developers who have
                            confusion between react and hooks in react. Well, it
                            is not different, react is a programming language
                            and hooks is ...
                          </p>
                          <a
                            href="https://dev.to/chamrasilva89/importance-of-reacts-hooks-b49"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="about-link-2"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="blog-main">
                        <a
                          href="https://dev.to/chamrasilva89/the-importance-of-uiux-in-software-engineering-4ldc"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="assets/img/blog/blog2.png"
                            alt="The importance of UI/UX"
                            className="blog-img"
                          />
                        </a>
                        <div className="blog-head">
                          <a
                            href="https://dev.to/chamrasilva89/the-importance-of-uiux-in-software-engineering-4ldc"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <h3>
                              <strong>
                                The importance of UI/UX | Software Engineering
                              </strong>
                            </h3>
                          </a>
                        </div>
                        <div className="blog-bottom">
                          <p>
                            UI or User Interface is the interface that is the
                            access point where users interact with computers. It
                            is also a way through which users can interact with
                            a website or an application. UI design typically
                            refers to graphical user interfaces but also
                            includes others, such as voice-controlled ones, a
                            keyboard and the appearance ...
                          </p>
                          <a
                            href="https://dev.to/chamrasilva89/the-importance-of-uiux-in-software-engineering-4ldc"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="about-link-2"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="blog-main">
                        <a
                          href="https://dev.to/chamrasilva89/real-time-software-design-bridging-the-gap-between-virtual-and-actual-5h8i"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="assets/img/blog/realtime.jpg"
                            alt="blog-img"
                            className="blog-img"
                          />
                        </a>
                        <div className="blog-head">
                          <a
                            href="https://dev.to/chamrasilva89/real-time-software-design-bridging-the-gap-between-virtual-and-actual-5h8i"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <h3>
                              <strong>Real-Time Software Design</strong>
                            </h3>
                          </a>
                        </div>
                        <div className="blog-bottom">
                          <p>
                            In an era defined by connectivity and instantaneity,
                            real-time software design stands as a crucial bridge
                            between virtual systems and tangible outcomes. The
                            concept revolves around creating software solutions
                            that respond to events as they occur, enabling
                            timely actions, monitoring, and interactions. This
                            article delves into the realm of real-time software
                            design, its significance, challenges, and
                            applications...
                          </p>
                          <a
                            href="https://dev.to/chamrasilva89/real-time-software-design-bridging-the-gap-between-virtual-and-actual-5h8i"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="about-link-2"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ textAlign: "center" }}>
                      <a
                        href="https://dev.to/chamrasilva89"
                        target="newtab"
                        className="btn btn-warning"
                        style={{
                          width: "50%",
                          fontSize: "16px",
                          backgroundColor: "#efd236",
                          borderColor: "#efd236",
                          color: "black",
                        }}
                      >
                        More Blog
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- ================================ CONTACT ========================== --> */}
        <div id="contact">
          <div className="contact-content">
            <div className="text-grid">
              <div className="text-grid-main">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="main-title text-center wow fadeIn">
                        <h3>Contact Me</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          I’m always open to discussing product design work or
                          partnership opportunities.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-grid">
              <div className="contact-form-details wow fadeIn">
                <div className="container">
                  {/* <div className="row contact-row">
                    <div className="col-md-8 col-md-offset-2 col-sm-12 col-sm-offset-1 contact-col">
                      <h3>Write Your Message Here</h3>
                      <div className="contact-form">
                        <form
                          action="https://herokuapp.us6.list-manage.com/subscribe/post?u=870e1b447d1f93893227a9c52&amp;id=85d6c939a5"
                          method="post"
                          id="mc-embedded-subscribe-form contactForm"
                          name="mc-embedded-subscribe-form"
                          className="contact-form shake validate"
                          target="_blank" 
                          data-toggle="validator"
                          novalidate
                        >
                          <div className="form-group">
                            <div className="controls">
                              <input
                                type="text"
                                name="FLNAME"
                                id="mce-FLNAME"
                                className="required form-control"
                                placeholder="Your Name"
                                required
                                data-error="Please enter your name"
                              />
                              <div className="help-block with-errors"></div>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="controls">
                              <input
                                type="email"
                                className="email required form-control"
                                name="EMAIL"
                                id="mce-EMAIL"
                                placeholder="Your Email"
                                required
                                data-error="Please enter your email"
                              />
                              <div className="help-block with-errors"></div>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="controls">
                              <input
                                type="phone"
                                name="PHONE"
                                className="phone form-control"
                                id="phone mce-PHONE"
                                placeholder="Your Phone"
                                required
                                data-error="Please enter your phone"
                              />
                              <div className="help-block with-errors"></div>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="controls">
                              <textarea
                                id="message mce-MESSAGE"
                                rows="7"
                                placeholder="Your Massage"
                                name="MESSAGE"
                                className="required form-control"
                                required
                                data-error="Please enter your message"
                              ></textarea>
                              <div className="help-block with-errors"></div>
                            </div>
                          </div>
                          <div id="mce-responses" class="clear">
                            <div
                              class="response"
                              id="mce-error-response"
                              style={{ display: "none" }}
                            ></div>
                            <div
                              class="response"
                              id="mce-success-response"
                              style={{ display: "none" }}
                            ></div>
                          </div>
                          <div
                            style={{ position: "absolute", left: "-5000px" }}
                            aria-hidden="true"
                          >
                            <input
                              type="text"
                              name="b_870e1b447d1f93893227a9c52_85d6c939a5"
                              tabindex="-1"
                              value=""
                            />
                          </div>
                          <button
                            type="submit"
                            value="Subscribe"
                            name="subscribe"
                            id="submit mc-embedded-subscribe"
                            className="btn btn-success"
                          >
                            Send Message
                          </button>
                          <div
                            id="msgSubmit"
                            className="h3 text-center hidden"
                          ></div>
                          <div className="clearfix"></div>
                        </form>
                      </div>
                    </div>
                  </div> */}
                  <div className="row contact-info-row text-center wow fadeIn">
                    <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".2s">
                        <i
                          className="fa fa-map-marker contact-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Address</h3>
                        <p>No : 335/5/A, Palanwatte, Pannipitiya, Sri Lanka</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".4s">
                        <i
                          className="fa fa-envelope contact-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Email</h3>
                        <a
                          href="mailto:chamarasilva028@gmail.com"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          chamarasilva028@gmail.com
                        </a>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".6s">
                        <i
                          className="fa fa-mobile contact-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Phone</h3>
                        <a
                          href="tel:+94715902088"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          +94715902088
                        </a>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".6s">
                        <i
                          className="fa fa-television contact-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Portfolio</h3>
                        <p>https://github.com/chamrasilva89</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container-fluid map-col">
                  <div class="col-md-12 col-sm-12 map-col">
                    <div class="google-maps">
                      <div class="map-wrap">
                        <iframe
                          referrerpolicy="no-referrer"
                          title="google-maps"
                          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1152.5515875890635!2d79.95001342054653!3d6.819046141453429!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2slk!4v1691815659112!5m2!1sen!2slk"
                          width="100%"
                          height="450"
                          style={{ border: "0" }}
                          allowfullscreen=""
                          loading="lazy"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Scroll to Top Button */}
        <div className="scroll-to-top">
          <button
            className="about-link-2 scroll-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <span className="up-arrow">&#9650;</span> Scroll to Top
          </button>
        </div>
      </div>
    </React.StrictMode>
  );
};

export default Home;
